// extracted by mini-css-extract-plugin
export default {"avatar":"UserTable_avatar__XuqbA","avatarPlaceholder":"UserTable_avatarPlaceholder__VZZqh"};